import React from "react";
import { useSelector } from "react-redux";

import { getLocale } from "@gamedev-web/gamedev-sdk-core";

import {
  AccountManager,
  DashboardHeader,
  MetaTags,
  OnboardingPageContainer,
  ProgramSelector,
} from "../../components";
import { getImage, ImageType } from "../../helpers/imageHelper";
import { SplitPane } from "../../components/SplitPane";
import { PageType } from "../../constants/pageType";
import { useOnProgramSelectionPageLoad } from "../../helpers/programSelectionPageHelpers";
import { useStrings } from "../../localization/localizationHelpers";

export const ProgramSelectionPage = () => {
  const [
    dashboardIntroTitle,
    dashboardMiddleText,
    dashboardHeaderProgramSelectionPageSubtitle,
    metaTitle,
    metaDescription,
    metaKeywords,
  ] = useStrings(
    "dashboardIntroTitle",
    "dashboardMiddleText",
    "dashboardHeaderProgramSelectionPageSubtitle",
    "programSelectionMetaTitle",
    "programSelectionMetaDescription",
    "programSelectionMetaKeywords"
  );
  useOnProgramSelectionPageLoad();

  const locale = useSelector(getLocale);

  return (
    <>
      <MetaTags
        title={metaTitle}
        description={metaDescription}
        keywords={metaKeywords}
        canonicalUrl={`https://developer.microsoft.com/${locale}/games/publish/program-selection`}
        imageUrl={getImage("idxboxlogo", ImageType.Png)}
      />

      <OnboardingPageContainer pageType={PageType.ProgramSelection}>
        <SplitPane rightPane={<div></div>}>
          <DashboardHeader
            title={dashboardIntroTitle}
            mainSubtitle={dashboardMiddleText}
            subtitle={dashboardHeaderProgramSelectionPageSubtitle}
          />
          <AccountManager isNdaUnderReviewStepOrAfter={false} />
          <ProgramSelector />
        </SplitPane>
      </OnboardingPageContainer>
    </>
  );
};
